import { MDBContainer } from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import { DataTable, useLoader } from "stm-frontend-library";
import {
    getJournals,
    getSubjects,
    showErrorToast,
    updateJournalSubjects
} from "../../helpers";
import { columns } from "./columns";
import SubjectsProvider from "./SubjectsContext";
import {SELECTED_JOURNAL_IDS_KEY} from "../../constants";
import {getSelectedJournalIds} from "../../helpers/journals";

const Journals = () => {
    const [data, setData] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const { showLoader, hideLoader, isLoading } = useLoader();
    const [lastSelectedRow, setLastSelectedRow] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                showLoader();
                const { data: response } = await getJournals();
                const arrResponse = response?.journals ?? [];

                const selectedJournalIds = await getSelectedJournalIds();

                const mappedArrResponse = arrResponse.map((journal) => {
                    const isJournalSelected = selectedJournalIds.includes(journal.id);

                    return {
                       ...journal,
                       clickEvent(row) {
                           setLastSelectedRow(row);
                       },
                       preselected: isJournalSelected
                   }
                });

                setData(mappedArrResponse);
            } catch (error) {
                showErrorToast();
            } finally {
                hideLoader();
            }
        }
        fetchData();

    }, [])

    useEffect(() => {
        const fetchSubjects = async () => {
            try {
                showLoader();
                const response = await getSubjects();

                setSubjects(response.data);
            } catch (error) {
                showErrorToast();
            } finally {
                hideLoader();
            }
        };

        fetchSubjects();
    }, []);

    const onSubjectsSave = async (subjects) => {
        showLoader();

        try {
            await updateJournalSubjects({
                journal_id: lastSelectedRow.id,
                subjects_ids: subjects.map((s) => s.id),
            });

            window.location.reload();
        } catch (error) {
            showErrorToast();
        } finally {
            hideLoader();
        }
    };

    const handleSelectRow = (checked, row) => {
        let selectedJournalIds =
            JSON.parse(localStorage.getItem(SELECTED_JOURNAL_IDS_KEY) || []);

        if (selectedJournalIds.includes(row.id) && !checked) {
            selectedJournalIds = selectedJournalIds.filter((id) => id !== row.id);
        } else {
            selectedJournalIds.push(row.id);
        }

        localStorage.setItem(
            SELECTED_JOURNAL_IDS_KEY,
            JSON.stringify(selectedJournalIds),
        );
    };

    const handleSelectAllRows = (checked, rows) => {
        localStorage.setItem(
            SELECTED_JOURNAL_IDS_KEY,
            JSON.stringify(rows.map((j) => j.id)),
        );
    };

    return (
        <MDBContainer className="my-5">
            <SubjectsProvider
                subjects={subjects}
                onSave={onSubjectsSave}
            >
                <DataTable
                    isLoading={isLoading}
                    rows={data}
                    columns={columns}
                    enableRowSelection={true}
                    onSelectRow={handleSelectRow}
                    onSelectAllRows={handleSelectAllRows}
                />
            </SubjectsProvider>
        </MDBContainer>
    )
}

export default Journals;
